import Button from "shared/components/button";
import Variant from "shared/enums/Variant";
import { RenderScrollableSelectOptionProps, ScrollableSelectOptionItemProps } from "../types";
import classNames from "classnames";
import React from "react";

export default function RenderScrollableSelectOption(props: RenderScrollableSelectOptionProps) {
  return (
    <ul data-testid={props.testId} className={classNames("scrollableTimePicker_column", props.className)}>
      {props.options.map(option => (
        <ScrollableSelectOptionItem
          key={option.value}
          label={option.label}
          isSelected={Boolean(props.selectedDate) && option.value.toString() === props.value?.toString()}
          clickHandler={() => props.onChange(option.value)}
        />
      ))}
    </ul>
  );
}

function ScrollableSelectOptionItem(props: ScrollableSelectOptionItemProps) {
  const ref = React.useRef<any>();
  React.useEffect(() => {
    if (props.isSelected && ref.current) {
      ref.current.parentElement.scrollTo?.({
        top: ref.current.offsetTop - 10
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <li ref={ref}>
      <Button.Custom
        variant={props.isSelected ? Variant.PRIMARY : Variant.LINK}
        title={props.label as string}
        onClick={props.clickHandler}>
        {props.label}
      </Button.Custom>
    </li>
  );
}
